export default "__VITE_ASSET__ccb3df29__"